import React, { useContext } from 'react';
import Spreadsheet from 'react-spreadsheet';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

import { ChillerLog } from '../../model';

interface AdditionalDetailsSubSectionProps {
  sectionChillerLog: ChillerLog;
  col: number;
}

const AdditionalDetailsSubSection: React.FunctionComponent<AdditionalDetailsSubSectionProps> = (props) => {
  let { sectionChillerLog, col } = props;

  let { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved, showRequiredFieldWarnings } =
    useContext(ChillerLogsContext);

  const handleSpreadsheetChange = (updatedData) => {
    updateChillerLogFieldIfChanged({
      chillerLog,
      setChillerLog,
      updatedData,
      getField: () => sectionChillerLog?.additional_details,
      setField: (log, value) => {
        log.additional_details = value;
      },
    });
  };

  let tableData = useFormattedTableData(
    sectionChillerLog?.additional_details,
    col,
    currentLogApproved,
    showRequiredFieldWarnings,
  );
  let columnLabels = ['', '', '', ''];

  return (
    <Spreadsheet
      data={tableData}
      hideRowIndicators
      columnLabels={[columnLabels[col]]}
      onChange={handleSpreadsheetChange}
      className={col === 3 ? 'chiller-spreadsheet third-column' : 'chiller-spreadsheet'}
      onBlur={saveCurrentLogToLocalStorage}
    />
  );
};

export default AdditionalDetailsSubSection;
